import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    modalWide: {
      boxSizing: 'border-box',
      justifyContent: 'space-between',
    },
    modal: {
      '& .MuiDialog-paperScrollPaper': {
        maxHeight: 'calc(100% - 30px)',
      },
    },
    addButton: {
      display: 'flex',
      justifyContent: 'flex-start',
      marginBottom: 20,
      marginLeft: 10,
    },
    head: {
      textAlign: 'center',
    },
    locationsWrapper: {
      maxWidth: '100%',
      margin: '0 10px',
    },
    loadingWindow: {
      display: 'flex',
      alignItems: 'center',
      minHeight: 200,
    },
    buttonsWrapper: {
      padding: 10,
    },
  }),
);

export default useStyles;
